<div class="d-flex justify-content-center align-items-center">
    <div class="alert-container">
        <div class="alert alert-icon-start bg-danger text-white alert-dismissible fade show"
            *ngIf="errorMessage | async as error">
            <span class="alert-icon bg-black bg-opacity-20">
                <i class="ph-bell-ringing"></i>
            </span>
            {{ 'modules.auth.common.message.error.' + error | translate }}
        </div>
        <div class="alert alert-icon-start bg-success text-white alert-dismissible fade show"
             *ngIf="successMessage | async as success">
            <span class="alert-icon bg-black bg-opacity-20">
                <i class="ph-bell-ringing"></i>
            </span>
            {{ 'modules.auth.common.message.success.' + success | translate }}
        </div>
    </div>
</div>
